/**
 *  This method is in a pure JS file rather than a
 *  typescript file so we can use the "import" to define
 *  a file to fetch.  Typescript compiler doesn't support this.
 * 
 * @param  callback - The callback function to call when the file is loaded.
 * @returns the file contents.
 */

const TOKEN_SEPARATOR = '\t';
const LABEL_SEPARATOR = '|';
const LABEL_VALUE_SEPARATOR = ':-';


export class Video {
  text = ""
  url = ""
  constructor(text, url) {
    this.text = text;
    this.url = url;
  }
}

export class Link {
  text = ""
  url = ""
  constructor(text, url) {
    this.text = text;
    this.url = url;
  }
}

export class Movie {
  text = ""
  url = ""
  image = ""
  constructor(text, url, image) {
    this.text = text;
    this.url = url;
    this.image = image;
  }
}

export class Book {
  text = ""
  url = ""
  image = ""
  constructor(text, url, image) {
    this.text = text;
    this.url = url;
    this.image = image;
  }
}

export class Level {
  parent = null;
  index = "";
  title = "";
  links = new Array();
  text = ""
  children = new Array();
  videos = new Array();
  movies = new Array();
  books = new Array();
  constructor(parent, index, title, links, text, children, videos, movies, books) {
    this.parent = parent;
    this.index = index;
    this.title = title;
    this.links = links;
    this.text = text;
    this.children = children;
    this.videos = videos;
    this.movies = movies;
    this.books = books
  }
}


export function createMap(textBlob) {
  const lineMap = new Map();
  const eol = require("eol");
  let lastLevel = null;
  /** 
   * Split text into lines and iterate over each line.
   */
  let lines = eol.split(textBlob);
  lines.forEach(function (line) {
    if ('' === line || '#' === line.trim().substring(0,1)) {
      return;
    }
    /**
     * For each line, split on the tab [0]=index [1]=content
     */
    let firstToken = '';
    let secondToken = '';
    if (-1 !== line.indexOf('\t')) {
      firstToken = line.substring(0, line.indexOf(TOKEN_SEPARATOR));
      secondToken = line.substring(line.indexOf(TOKEN_SEPARATOR) + 1);
    } else {
      console.warn('Line did not contain two parts separated by tab: ' + line);
      return;
    }

    /**
     * Make sure the first token ends in '.'
     */
    if (!firstToken.endsWith('.') && !firstToken.endsWith(':')) {
      console.warn('First token does not end with . or :! Line:' + line);
      return;
    }
    /**
     * If we have a number for the first token, the token is the level index.
     * Otherwise the token is a level attribute.
     */
    if (-1 !== firstToken.indexOf('.')) {
      let lineIndex = firstToken.trim().substring(0, firstToken.lastIndexOf('.'));
      lastLevel = lineIndex;
      /**
     * Determine if this line is a child of another level.  If we
     * subtract a level from the index and the new index exists, there is
     * a parent level.
     * 
     * Note - the only levels that won't have a parent level are the top levels.
     */
      if (lineIndex.replace('.', '').length > 1) {
        /**
         * Find the parent level and add this line as a child of that level.
         */
        let parentLevelIndex = lineIndex.substring(0, lineIndex.lastIndexOf('.'));
        if (lineMap.has(parentLevelIndex)) {
          let currentParentLevel = lineMap.get(parentLevelIndex);
          let newLevel = new Level();
          newLevel.parent = currentParentLevel;
          newLevel.index = lineIndex;
          newLevel.links = new Array();
          newLevel.children = new Array();
          newLevel.movies = new Array();
          newLevel.books = new Array();
          newLevel.videos = new Array();
          newLevel.title = secondToken;
          newLevel.text = '';
          newLevel.image = '';
          /**
           * Create a new parent level with this as a 
           * added child.
           */
          let newParentLevel = new Level();
          newParentLevel.parent = currentParentLevel.parent;
          newParentLevel.index = currentParentLevel.index;
          newParentLevel.title = currentParentLevel.title;
          newParentLevel.text = currentParentLevel.text;
          newParentLevel.image = currentParentLevel.image;
          newParentLevel.links = currentParentLevel.links;
          newParentLevel.books = currentParentLevel.books;
          newParentLevel.videos = currentParentLevel.videos;
          newParentLevel.movies = currentParentLevel.movies;
          newParentLevel.children = currentParentLevel.children.concat(newLevel);
          /**
           * Add both new levels to the map.
           */
          lineMap.set(currentParentLevel.index, newParentLevel);
          lineMap.set(newLevel.index, newLevel);
        }
      } else {
        let newLevel = new Level();
        newLevel.parent = null;
        newLevel.index = lineIndex;
        newLevel.links = new Array();
        newLevel.children = new Array();
        newLevel.movies = new Array();
        newLevel.books = new Array();
        newLevel.videos = new Array();
        newLevel.title = secondToken;
        newLevel.text = '';
        newLevel.image = '';
        lineMap.set(lineIndex, newLevel);
      }
    } else {
      /**
       * Add this level attribute to the last level based on attribute type
       */
      if (lineMap.has(lastLevel)) {
        // if(lastLevel === '1.1.8') {
        //   console.log("found level");
        // }
        let existingLevel = lineMap.get(lastLevel);
        switch (firstToken.toLowerCase()) {
          case 'link:':
            /**
             * Line format
             * link:\ttext:<text>|url:<url>
             */
            let newLink = new Link();
            let linkTokens = secondToken.split(LABEL_SEPARATOR);
            
            if (linkTokens && 2 === linkTokens.length) {
              linkTokens.forEach(tokenLine => {
                let tokenValue = tokenLine.split(LABEL_VALUE_SEPARATOR);
                switch (tokenValue[0]) {
                  case 'text':
                    newLink.text = tokenValue[1];
                    break;
                  case 'url':
                    newLink.url = tokenValue[1];
                    break;
                  default:
                }
              });
              if (!existingLevel.links) {
                existingLevel.links = new Array();
              }
              existingLevel.links = existingLevel.links.concat(newLink);
            } else {
              console.warn('invalid number of tokens: ' + linkTokens.length + ' for line: ' + line);
            }
            break;
          case 'text:':
            existingLevel.text = secondToken;
            break;
          case 'movie:':
            /**
            * Line format
            * movie:\ttext:<text>|image:<image>|url:<url>
            */
            let newMovie = new Movie();
            let movieTokens = secondToken.split(LABEL_SEPARATOR);
            if (movieTokens && 3 === movieTokens.length) {
              movieTokens.forEach(tokenLine => {
                let tokenValue = tokenLine.split(LABEL_VALUE_SEPARATOR);
                switch (tokenValue[0]) {
                  case 'text':
                    newMovie.text = tokenValue[1];
                    break;
                  case 'url':
                    newMovie.url = tokenValue[1];
                    break;
                  case 'image':
                    newMovie.image = tokenValue[1];
                    break;
                  default:
                }
              });
              if (!existingLevel.movies) {
                existingLevel.movies = new Array();
              }
              existingLevel.movies = existingLevel.movies.concat(newMovie);
            } else {
              console.warn('invalid number of tokens: ' + movieTokens.length + ' for line: ' + line);
            }
            break;
          case 'book:':
            /**
            * Line format
            * book:\ttext:<text>|image:<image>|url:<url>
            */
            let newBook = new Book();
            let bookTokens = secondToken.split(LABEL_SEPARATOR);
            if (bookTokens && 3 === bookTokens.length) {
              bookTokens.forEach(tokenLine => {
                let tokenValue = tokenLine.split(LABEL_VALUE_SEPARATOR);
                switch (tokenValue[0]) {
                  case 'text':
                    newBook.text = tokenValue[1];
                    break;
                  case 'url':
                    newBook.url = tokenValue[1];
                    break;
                  case 'image':
                    newBook.image = tokenValue[1];
                    break;
                  default:
                }
              });
              if (!existingLevel.books) {
                existingLevel.books = new Array();
              }
              existingLevel.books = existingLevel.books.concat(newBook);
            } else {
              console.warn('invalid number of tokens: ' + bookTokens.length + ' for line: ' + line);
            }
            break;
          case 'video:':
            /**
            * Line format
            * video:\ttext:<text>|url:<url>
            */
            let newVideo = new Video();
            let videoTokens = secondToken.split(LABEL_SEPARATOR);
            if (videoTokens && 2 === videoTokens.length) {
              videoTokens.forEach(tokenLine => {
                let tokenValue = tokenLine.split(LABEL_VALUE_SEPARATOR);
                switch (tokenValue[0]) {
                  case 'text':
                    newVideo.text = tokenValue[1];
                    break;
                  case 'url':
                    newVideo.url = tokenValue[1];
                    break;
                  default:
                }
              });
              if (!existingLevel.videos) {
                existingLevel.videos = new Array();
              }
              existingLevel.videos = existingLevel.videos.concat(newVideo);
            } else {
              console.warn('invalid number of tokens: ' + videoTokens.length + ' for line: ' + line);
            }
            break;
          default:
        }
        /*
        console.log('\n adding entry to map. index:' + lastLevel + ' level:\n'
          + 'parent: ' + existingLevel.parent + '\n'
          + 'title: ' + existingLevel.title + '\n');
        if (existingLevel.videos && existingLevel.videos.length > 0) {
          console.log('videos:');
          existingLevel.videos.forEach(video => { console.log('text:' + video.text + '\n url:' + video.url); });
        }
        */

        lineMap.set(lastLevel, existingLevel);
        /*
        let tempLevel = lineMap.get(lastLevel);
        console.log('\n Getting entry to map. index:' + lastLevel + ' level:\n'
          + 'parent: ' + tempLevel.parent + '\n'
          + 'title: ' + tempLevel.title + '\n');

        if (tempLevel.videos && tempLevel.videos.length > 0) {
          console.log('videos:');
          tempLevel.videos.forEach(video => { console.log('text:' + video.text + '\n url:' + video.url); });
        }
        */

      } else {
        console.warn('invalid token: ' + firstToken + ' Current level does not exist: ' + lastLevel);
      }

    }

  });
  return lineMap;
}